var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HomepageUpsell/HomepageUpsell.jsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable zillow/react/no-danger */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Paragraph, Heading, Image, IconButton, IconCloseCircle } from '@zillow/constellation';
import { useYieldCallback } from '@zillow/yield-callback';
import { NewLaneEvent } from '../../../../../eventing/NewLaneEvent';
import { DSP_BRAND, DSP_EXPERIENCE } from '../../../../internal/constants';
import { formNewLaneEventPayload } from '../../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../../eventing/clickStreamEventSchema';
import { useOnsiteMessagingImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
import { imageAlt } from '../utils/helper';
export var HomepageUpsell = function HomepageUpsell(_ref) {
  var imageMedia = _ref.imageMedia,
      header = _ref.header,
      bodyText = _ref.bodyText,
      eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData;
  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  var collapseAction = useYieldCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'click'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData);
    NewLaneEvent(oldDspPayload, newLanePayload);
  }, [eventData, newLaneEventData, additionalClickStreamData]);
  var expandAction = useYieldCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'secondaryClick'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData, true);
    NewLaneEvent(oldDspPayload, newLanePayload);
  }, [eventData, newLaneEventData, additionalClickStreamData]);
  var onHoverAction = useCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'hover'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData);
    NewLaneEvent(oldDspPayload, newLanePayload);
  }, [eventData, newLaneEventData, additionalClickStreamData]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var collapse = function collapse() {
    setCollapsed(true);
    collapseAction();
  };

  var expand = function expand() {
    if (collapsed) {
      setCollapsed(false);
      expandAction();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      'display': 'flex',
      'justify-content': 'flex-end',
      'width': '550px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    onMouseEnter: onHoverAction,
    onClick: expand,
    sx: {
      'overflow': 'hidden',
      'padding': '$spacing.md',
      'display': 'flex',
      'borderRadius': '$radii.lg',
      'background': '$colors.backgroundWhite',
      'box-shadow': '$shadows.shadow400',
      '@keyframes collapseAnimation': {
        from: {
          width: '100%'
        },
        to: {
          width: '152px'
        }
      },
      '@keyframes expandAnimation': {
        from: {
          width: '152px'
        },
        to: {
          width: '100%'
        }
      },
      'animation': collapsed ? 'collapseAnimation' : 'expandAnimation',
      // TODO: Use $animations.defaultDuration when https://zillowgroup.atlassian.net/browse/CDS-3247 is fixed
      'animation-duration': '0.2s',
      'animation-timing-function': '$animations.defaultTimingFunction',
      'animation-fill-mode': 'forwards',
      'cursor': collapsed ? 'pointer' : 'default'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: Image,
    alt: imageAlt(imageMedia),
    src: imageMedia.src,
    sx: {
      'max-width': '104px',
      'max-height': '104px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 21
    }
  }), !collapsed && /*#__PURE__*/React.createElement(Box, {
    sx: {
      'overflow': 'hidden',
      'min-width': '344px',
      'marginLeft': '$spacing.md'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 29
    }
  }, header), /*#__PURE__*/React.createElement(Paragraph, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 29
    }
  }, bodyText)), collapsed && /*#__PURE__*/React.createElement(Box, {
    sx: {
      'overflow': 'hidden',
      'min-width': '344px',
      'visibility': 'hidden'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 29
    }
  }, header), /*#__PURE__*/React.createElement(Paragraph, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 29
    }
  }, bodyText)), !collapsed && /*#__PURE__*/React.createElement(Box, {
    onClick: collapse,
    as: IconButton,
    sx: {
      top: '-10px'
    },
    bare: true,
    appearance: "circle",
    title: "collapse",
    icon: /*#__PURE__*/React.createElement(IconCloseCircle, {
      fontColor: "gray500",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 178,
        columnNumber: 35
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 25
    }
  }))));
};
HomepageUpsell.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The action link for clicking on the component
   */
  header: PropTypes.string.isRequired,

  /**
   * The action text displayed in component
   * */
  bodyText: PropTypes.string.isRequired,

  /**
   * Background image displayed in component
   */
  imageMedia: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),

  /**
   * Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: PropTypes.object,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object
} : {};
HomepageUpsell.defaultProps = {
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {}
};